import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types.ts';

const url: unknown = import.meta.env['VITE_SUPABASE_URL'];
const key: unknown = import.meta.env['VITE_SUPABASE_PUBLISHABLE_KEY'];
if (
  typeof url !== 'string' ||
  !url.startsWith('https://') ||
  typeof key !== 'string' ||
  key === ''
) {
  throw new Error('VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY must be set at build time');
}

/** Publishable key only: every read is limited by RLS, every write is an owner-checked function. */
export const supabase = createClient<Database>(url, key, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});
